export default {"src":"/blogs/_next/static/media/link.dd32f21b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};